export default "__VITE_ASSET__S7v$sZr5__"